import request from "@/utils/request.js";

export function getList(params){
    return request({
        url: "/material/materialapp/api/admin/materialWarehouse/list",
        method: "GET",
        params
    })
}